module.exports = __webpack_public_path__ + "img/icon_steel.54b43bbc.png";